import { render, staticRenderFns } from "./BaseTableCardNoHeader.vue?vue&type=template&id=2980ae67"
import script from "./BaseTableCardNoHeader.vue?vue&type=script&lang=js"
export * from "./BaseTableCardNoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports